import Vue from 'vue'
import { ENDPOINTS } from './endpoints'
import { queryAdder } from './helper'

function transformRequest (ENDPOINT, query, data, headers) {
  return (ENDPOINT.METHOD.toLowerCase() === 'get')
      ? Vue.http[ENDPOINT.METHOD.toLowerCase()](queryAdder(ENDPOINT.URL, query), data, headers)
      : Vue.http[ENDPOINT.METHOD.toLowerCase()](ENDPOINT.URL, data, headers)
}

function callEndpoint (ENDPOINT, data = null, query = null, headers = null) {
  return new Promise((resolve, reject) => {
    transformRequest(ENDPOINT, query, data, headers)
      .then(response => { return response.json() })
      .then(data => { resolve(data) })
      .catch(error => { reject(error) })
  })
}

export const APIService = {
  login (data) { return callEndpoint(ENDPOINTS.LOGIN, data) },
  beforeResetPassword(data) { return callEndpoint(ENDPOINTS.BEFORE_RESET_PASSWORD, data) },
  resetPassword(data) { return callEndpoint(ENDPOINTS.RESET_PASSWORD, data) },
  
  googleGetDistance (data) { 
    return Vue.http.get(
        queryAdder(ENDPOINTS.GOOGLE_DISTANCE.URL, data),
        {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
              'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
        }
    )
  },
  
  hereGetPlace (data) { return Vue.http.get(queryAdder(ENDPOINTS.HERE_API_PLACES.URL, data)) },
  hereGetDistance (data) { return Vue.http.get(queryAdder(ENDPOINTS.HERE_API_DISTANCE.URL, data)) },
  
  notaSpeseGetAll () { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_ALL_NOTE) },
  notaSpeseGetAnticipoAzienda (data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_SPESE_AZIENDALE, data) },
  notaSpeseGetSpeseAutorizzate (data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_SPESE_AUTORIZZATE, data) },
  notaSpeseAddNota (data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.ADD_NOTA, data) },
  chiudiMeseSpesa (data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.CHIUDI_MESE, data) },
  inviaRichiestaAutorizzazione (data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.INVIA_AUTORIZZAZIONE, data) },
  
  targaGetAll () { return callEndpoint(ENDPOINTS.TARGA.GET_ALL) },
  targaNew (data) { return callEndpoint(ENDPOINTS.TARGA.NEW, data) },
  removeLoginPrivato (data) { return callEndpoint(ENDPOINTS.TARGA.REMOVE_LOGIN, {body: data}) },
  addLoginPrivato (data) { return callEndpoint(ENDPOINTS.TARGA.ADD_LOGIN, data) },
  
  trattaGetAll () { return callEndpoint(ENDPOINTS.TRATTA.GET_ALL) },
  trattaGetAllCitta () { return callEndpoint(ENDPOINTS.TRATTA.GET_ALL_CITTA) },
  trattaGetAllVia () { return callEndpoint(ENDPOINTS.TRATTA.GET_ALL_VIA) },
  trattaNew (data) { return callEndpoint(ENDPOINTS.TRATTA.NEW, data) },
  getNote(data) {return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_NOTE, data) },
  firmaNota(data) {return callEndpoint(ENDPOINTS.NOTA_SPESE.FIRMA_NOTA, data) },
  getNota(data) {return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_NOTA, data) },
  updateNota(data) {return callEndpoint(ENDPOINTS.NOTA_SPESE.UPDATE_NOTA, data) },
  reinviaCodice(data) {return callEndpoint(ENDPOINTS.NOTA_SPESE.REINVIA_CODICE, data) },
  existNota(data) {return callEndpoint(ENDPOINTS.NOTA_SPESE.EXIST_NOTA, data) },
  removeNotaSpesa(data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.REMOVE_NOTA_SPESA, data) },
  notaSpeseGetDaModifica() { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_ALL_NOTE_DA_MODIFICARE) },
  notaSpeseGetAllRichiesteMensile() { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_ALL_RICHIESTE_MENSILE) },
  notaSpeseGetStatisticaRichieste(data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_STATISTICA_RICHIESTE, data) },
  notaSpeseGetDettaglioRichiesteCategoria(data) { return callEndpoint(ENDPOINTS.NOTA_SPESE.GET_DETTAGLIO_CATEGORIA, data) },

  getValute(data) {
    return Vue.http[ENDPOINTS.NOTA_SPESE.GET_VALUTE.METHOD.toLowerCase()](ENDPOINTS.NOTA_SPESE.GET_VALUTE.URL + data +
                  '?access_key=cbb3d0b9285492e36b18a4f122db5968&format=1&symbols=ALL') },
    getioneGetNoteDaVerificare() { return callEndpoint(ENDPOINTS.GESTIONE.GET_NOTE_VERIFICA) },
    getioneGetAutoDaVerificare() { return callEndpoint(ENDPOINTS.GESTIONE.GET_AUTO_VERIFICA) },
    getioneGetTratteDaVerificare() { return callEndpoint(ENDPOINTS.GESTIONE.GET_TRATTE_VERIFICA) },
    getioneChangeTrattaItem(data) { return callEndpoint(ENDPOINTS.GESTIONE.CHANGE_TRATTA_ITEM, data) },
    gestioneSetCoefficiente(data) { return callEndpoint(ENDPOINTS.GESTIONE.SET_COEFFICIENTE, data) },
    gestioneConfirmNotaSpesa(data) { return callEndpoint(ENDPOINTS.GESTIONE.CONFIRM_NOTA_SPESA, data) },
    getioneGetDettaglioSpesa(data) { return callEndpoint(ENDPOINTS.GESTIONE.GET_DETAGLIO_SPESA, data) },
    getioneProtocollaSpesa(data) { return callEndpoint(ENDPOINTS.GESTIONE.PROTOCOLLA_SPESA, data) },

  getioneConfermaProtocolloSpesa(data) { return callEndpoint(ENDPOINTS.GESTIONE.PROTOCOLLO_CONFERMA, data) },
  AdminGetioneGetNoteDaVerificare() { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_NOTE_VERIFICA) },
  AdminGetioneGetAutoDaVerificare() { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_AUTO_VERIFICA) },
  AdminGetioneGetTratteDaVerificare() { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_TRATTE_VERIFICA) },
  AdminGetioneChangeTrattaItem(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.CHANGE_TRATTA_ITEM, data) },
  AdminGestioneSetCoefficiente(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.SET_COEFFICIENTE, data) },
  AdminGestioneConfirmNotaSpesa(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.CONFIRM_NOTA_SPESA, data) },
  AdminGetioneGetDettaglioSpesa(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_DETAGLIO_SPESA, data) },
  AdminGetioneInviaSpesa(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.INVIA_SPESA, data) },
  AdminGetioneProtocollaSpesa(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.PROTOCOLLA_SPESA, data) },
  AdminGetioneConfermaProtocolloSpesa(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.PROTOCOLLO_CONFERMA, data) },
  reportAdminGetMensile(data) { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_REPORT_MENSILE, data) },

  SammGetioneGetNoteDaVerificare() { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.GET_NOTE_VERIFICA) },
  SammGetioneGetAutoDaVerificare() { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.GET_AUTO_VERIFICA) },
  SammGetioneGetTratteDaVerificare() { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.GET_TRATTE_VERIFICA) },
  SammGetioneChangeTrattaItem(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.CHANGE_TRATTA_ITEM, data) },
  SammGetioneToggleTrattaItem(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.TOGGLE_TRATTA_ITEM, data) },
  SammGestioneSetCoefficiente(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.SET_COEFFICIENTE, data) },
  SammGestioneConfirmNotaSpesa(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.CONFIRM_NOTA_SPESA, data) },
  SammGetioneGetDettaglioSpesa(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.GET_DETAGLIO_SPESA, data) },
  SammGetioneInviaSpesa(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.INVIA_SPESA, data) },
  SammGestioneUpdateAuto(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.UPDATE_AUTO, data) },
  SammGetAutoLibterro(data) { return callEndpoint(ENDPOINTS.SAMM_GESTIONE.GET_AUTO_LIBRETTO, data) },
  
  reportGetMensile(data) { return callEndpoint(ENDPOINTS.REPORT.GET_MENSILE, data) },
  reportCheckNonProtocollate() { return callEndpoint(ENDPOINTS.REPORT.GET_NON_PROTOCOLLATE) },
  reportProtocollaSpesa(data) { return callEndpoint(ENDPOINTS.REPORT.GET_PROTOCOLLO_SPESA, data) },
  confermaProtocolloSpesa(data) { return callEndpoint(ENDPOINTS.REPORT.PROTOCOLLA_SPESA, data) },
  beforeReportProtocollaSpesa(data) { return callEndpoint(ENDPOINTS.REPORT.BEFORE_PROTOCOLLA_SPESA, data) },
  
  
  
  //MODIFICHE VINCENZO
  getPreautorizzati(){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_PREAUTORIZZATI)},
  eliminaPreautorizzato(data){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.ELIMINA_PREAUTORIZZATO, data)},
  getRichieste(){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_RICHIESTE)},
  salvaPreautorizzato(data){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.SALVA_PREAUTORIZZATO, data)},
  confermaAutorizzazione(data){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.CONFERMA_AUTORIZZAZIONE, data)},
  eliminaAutorizzazione(data){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.ELIMINA_AUTORIZZAZIONE, data)},
  getAllUsers(){ return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_ALLUSERS)},

  
  SETTINGS: {
    getAllUtenti () { return callEndpoint(ENDPOINTS.ADMIN_GESTIONE.GET_ALLUSERS) },
    resetPassword (data) { return callEndpoint(ENDPOINTS.SETTINGS.RESET_PASSWORD, data) },
  },
  
  
  
  
}


// WEBPACK FOOTER //
// ./modules/Home/views/src/services/index.js